/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../state/action/globalAction";
import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { getTugHistoryOptions } from "../../utils/constants";
import "../tugFront/history/fronthistory.scss";
import CommonLollipopChart from "../chart/lollipop/CommonLollipopChart";
import InvertedColumnChart from "../chart/column/InvertedColumnChart";
import { columnFront, sidelimits } from "../../utils/graphConstants";
import { getV5MetricHistory, usergetInfo } from "../../services/romReports";
import { pageLocale } from "../../utils/locale";
import SnackBar from "../snack-bar/SnackBar";
import { StraightLineModels } from "../tugFront/summary/StraightLineConstants";
import { forHistoryScoreShow } from "../../utils/pdfGraphConstants";
import { statusHandler } from "../../utils/commonfunction";
import UserDetails from "../tugFront/UserDetails";
import goodSmiley from "../../assets/goodSmiley.svg";
import moderateSmiley from "../../assets/moderateSmiley.svg";
import badSmiley from "../../assets/badSmiley.svg";
import { getParams } from "../../utils/helpers";

const TugHistory = ({ reportType = "front" }) => {
  const isSide = reportType === "side";

  const [mainOption, setMainOption] = useState(0);
  const [subOptions, setSubOptions] = useState(0);

  const setMain = (e) => {
    setSubOptions(0);
    setMainOption(e.target.value);
  };

  const featureFlag = useSelector((state) => state.global.featureFlag);
  const { metrics } = getParams();
  const hideBands = featureFlag || metrics === "true";

  const baseOption = getTugHistoryOptions(reportType).filter(
    (option) => option.subOptions.length > 0,
  );
  const tugMainOption = hideBands
    ? baseOption.map((option) => ({
        ...option,
        subOptions: option.subOptions.filter(
          (subOption) => subOption.value !== "summary",
        ),
      }))
    : [...baseOption];

  const validSubOptionsIndex = Math.min(
    subOptions,
    (tugMainOption[mainOption]?.subOptions?.length || 1) - 1,
  );

  const selectedSubOption =
    tugMainOption[mainOption]?.subOptions[validSubOptionsIndex];
  const type = selectedSubOption?.type || tugMainOption[mainOption]?.value;
  const subType = selectedSubOption?.value;

  const [userData, setUserdata] = useState();
  const [historyData, setHistoryData] = useState([]);
  const [criteriaData, setCriteriaData] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState({
    flag: false,
    text: null,
  });
  const { errorCode } = pageLocale("common");
  const {
    good,
    average,
    poor,
    criteria,
    sit_to_standup_time,
    good_cap,
    average_cap,
    poor_cap,
  } = pageLocale("newreport");

  const openErrorHandleClose = () => {
    setOpenErrorAlert({ flag: false, text: null });
  };

  const isLoading = useSelector((state) => state.global.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(true));
    usergetInfo()
      .then((res) => {
        setUserdata(res.data?.data);
      })
      .catch((err) => {
        if (err.response?.status === 401 || err.response?.status === 403) {
          setOpenErrorAlert({ flag: true, text: errorCode });
        } else {
          setOpenErrorAlert({ flag: true, text: err.response?.data?.message });
        }
      });

    const historyPromise = getV5MetricHistory(type, subType, 5).then((res) => ({
      data: res?.data?.data?.data || [],
      criteria: res?.data?.data?.criteria || res?.data?.criteria || {},
    }));

    historyPromise
      .then(({ data, criteria }) => {
        setHistoryData(data);
        setCriteriaData(criteria);
        dispatch(setLoading(false));
      })
      .catch((err) => {
        setHistoryData([]);
        setCriteriaData([]);
        if (err.response?.status === 401 || err.response?.status === 403) {
          setOpenErrorAlert({ flag: true, text: errorCode });
        } else {
          setOpenErrorAlert({ flag: true, text: err.response?.data?.message });
        }
        dispatch(setLoading(false));
      });
  }, [type, subType]);

  useEffect(() => {
    const maxSubOptionsIndex =
      (tugMainOption[mainOption]?.subOptions?.length || 1) - 1;
    if (subOptions > maxSubOptionsIndex) {
      setSubOptions(0);
    }
  }, [hideBands, mainOption, subOptions, tugMainOption]);

  const ImageShow = () => {
    const graphType =
      tugMainOption[mainOption]?.subOptions[validSubOptionsIndex].graphReference;
    const [lastVal] = historyData.slice(-1);
    const rangeList = StraightLineModels[graphType]?.range;
    const lastValObject = isSide
      ? lastVal?.value ?? lastVal?.time
      : lastVal?.value;

    if (lastValObject === null || lastValObject === undefined || lastValObject === "") return null;
    if (!Number.isFinite(Number(lastValObject))) return null;

    let rangeType = rangeList?.find((p) =>
      eval(p.cond.replace(/X/g, Number(Math.abs(lastValObject).toFixed(2)))),
    );

    if (isSide && graphType === "timeToStandUp") {
      rangeType = {};
      if (lastValObject <= criteriaData.good) rangeType.type = good;
      else if (lastValObject > criteriaData.bad) rangeType.type = poor;
      else rangeType.type = average;
    }

    switch (rangeType?.type) {
      case good:
        return <img src={goodSmiley} alt="good" className="img" />;
      case average:
        return <img src={moderateSmiley} alt="moderate" className="img" />;
      case poor:
        return <img src={badSmiley} alt="poor" className="img" />;
      default:
        return null;
    }
  };

  const mapValues = (type, value) => {
    switch (type) {
      case "good":
        return "<= " + value.good;
      case "moderate":
        return "> " + value.good + " ~ <= " + value.moderate;
      case "bad":
        return "> " + value.bad;
      default:
        return "";
    }
  };

  const valueStatusHandler = (type) => {
    switch (type) {
      case "good":
        return good_cap;
      case "moderate":
        return average_cap;
      case "bad":
        return poor_cap;
      default:
        return "";
    }
  };

  const graphReference =
    tugMainOption[mainOption]?.subOptions[validSubOptionsIndex]?.graphReference;

  return (
    <>
      <Layout>
        <div className="history-main-wrapper">
          {userData && (
            <UserDetails
              name={userData?.name}
              firstName={userData?.first_name}
              lastName={userData?.last_name}
              gender={userData?.gender}
              age={userData?.age}
            />
          )}
          <div className="option-main-wrapper">
            <FormControl className="history-menuitem-list">
              <Select
                className="histroy-item"
                onChange={setMain}
                value={mainOption}
              >
                {tugMainOption.map((f, k) => (
                  <MenuItem value={k} key={f.value}>
                    {f.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl className="history-menuitem-list">
              <Select
                className="histroy-item"
                onChange={(e) => setSubOptions(e.target.value)}
                value={validSubOptionsIndex}
              >
                {tugMainOption[mainOption].subOptions.map((f, k) => (
                  <MenuItem value={k} key={f.value}>
                    {f.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="graph-history-first-block">
            <div className="history-header">
              <div className="history-title-wrap">
                <Typography className="title">
                  {tugMainOption[mainOption].subOptions[validSubOptionsIndex].text}
                </Typography>
                <Typography className="measurement">
                  {tugMainOption[mainOption].subOptions[validSubOptionsIndex].unit}
                </Typography>
              </div>
              {!hideBands && <ImageShow />}
            </div>
            <div className="chart-main-wrap">
              {!isLoading && (
                <div className="chart-wrapper">
                  {tugMainOption[mainOption].subOptions[validSubOptionsIndex]
                    .chartType === "column" ? (
                    <InvertedColumnChart
                      graphOptions={columnFront[graphReference]}
                      historyData={historyData}
                      hidePlotLines={hideBands}
                    />
                  ) : (
                    <CommonLollipopChart
                      graphOptions={sidelimits[graphReference]}
                      historyData={historyData}
                      criteriaData={criteriaData}
                      hidePlotLines={hideBands}
                    />
                  )}
                </div>
              )}
            </div>
          </div>

          {!hideBands && (
            <div className="graph-value-wrapper">
              <Typography className="criteria-header-text">
                {criteria +
                  " " +
                  tugMainOption[mainOption].subOptions[validSubOptionsIndex].unit}
              </Typography>
              <div className="graph-item">
                <div className="value-item">
                  {tugMainOption[mainOption].subOptions[validSubOptionsIndex].text ===
                    sit_to_standup_time
                    ? Object.keys(criteriaData)?.map((i) => {
                        return (
                          <div key={i} className="range-values">
                            <Typography
                              className="value"
                              style={{ color: statusHandler(i) }}
                            >
                              {valueStatusHandler(i)}
                            </Typography>
                            <Typography className="status">
                              {mapValues(i, criteriaData)}
                            </Typography>
                          </div>
                        );
                      })
                    : forHistoryScoreShow[graphReference]?.range?.map((i) => {
                        return (
                          <div key={i.text} className="range-values">
                            <Typography
                              className="value"
                              style={{ color: statusHandler(i?.status) }}
                            >
                              {i?.status}
                            </Typography>
                            <Typography className="status">
                              {i?.text}
                            </Typography>
                          </div>
                        );
                      })}
                </div>
                {!isSide &&
                  tugMainOption[mainOption].subOptions[validSubOptionsIndex]
                    .chartType === "column" && (
                  <div className="vertical-seperater"></div>
                )}
                {!isSide &&
                  tugMainOption[mainOption].subOptions[validSubOptionsIndex]
                    .chartType === "column" && (
                  <div className="elevated-text-box">
                    <div className="elevate-item">
                      <Typography className="text">+Θ</Typography>
                      <Typography className="text">
                        {pageLocale("newreport").elevated}
                      </Typography>
                    </div>
                    <div className="elevate-item">
                      <Typography className="text">-Θ</Typography>
                      <Typography className="text">
                        {pageLocale("newreport").depressed}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Layout>
      <SnackBar open={openErrorAlert} closeHandler={openErrorHandleClose} />
    </>
  );
};

export default TugHistory;
